import { render, staticRenderFns } from "./ListPoi.vue?vue&type=template&id=3cdf9af2&"
import script from "./ListPoi.vue?vue&type=script&lang=js&"
export * from "./ListPoi.vue?vue&type=script&lang=js&"
import style0 from "./ListPoi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports